import React, { useContext, useState } from "react";
import {
  Col,
  Dropdown,
  DropdownMenu,
  DropdownToggle,
  Nav,
  NavItem,
  NavLink,
  Row,
  TabContent,
  TabPane,
  Button,
} from "reactstrap";
import classnames from "classnames";
import SimpleBar from "simplebar-react";
import bell from "../../assets/images/svg/bell.svg";
import { NotificationContext } from "../Context/NotificationContext";


const NotificationDropdown = () => {
  const [isNotificationDropdown, setIsNotificationDropdown] = useState(false);
  const [activeTab, setActiveTab] = useState("1");

  const { notifications, deleteAllNotifications, markAsRead } = useContext(NotificationContext);


  const toggleNotificationDropdown = () =>
    setIsNotificationDropdown(!isNotificationDropdown);

  const toggleTab = (tab) => setActiveTab(tab);

const unreadCount = notifications.filter(
  (n) => !n.isRead
).length;


  return (
    <Dropdown
      isOpen={isNotificationDropdown}
      toggle={toggleNotificationDropdown}
      className="topbar-head-dropdown ms-1 header-item"
    >
      <DropdownToggle
        type="button"
        tag="button"
        className="btn btn-icon btn-topbar btn-ghost-secondary rounded-circle"
      >
        <i className="bx bx-bell fs-22"></i>
        {unreadCount > 0 && (
          <span className="position-absolute topbar-badge fs-10 translate-middle badge rounded-pill bg-danger">
            {unreadCount}
          </span>
        )}
      </DropdownToggle>

      <DropdownMenu className="dropdown-menu-lg dropdown-menu-end p-0">
        <div className="dropdown-head bg-primary bg-pattern rounded-top">
          <div className="p-3">
            <Row className="align-items-center">
              <Col>
                <h6 className="m-0 fs-16 fw-semibold text-white">Notifications</h6>
              </Col>
              <div className="col-auto dropdown-tabs d-flex align-items-center gap-2">
                <span className="badge bg-light-subtle text-body fs-13">
                  {unreadCount} New
                </span>
                {notifications.length > 0 && (
                  <Button
                    color="danger"
                    size="sm"
                    className="px-2 py-1"
                    onClick={deleteAllNotifications}
                  >
                    <i className="bx bx-trash me-1"></i> Clear All
                  </Button>
                )}
              </div>
            </Row>
          </div>

          <div className="px-2 pt-2">
            <Nav className="nav-tabs dropdown-tabs nav-tabs-custom">
              <NavItem>
                <NavLink
                  href="#"
                  className={classnames({ active: activeTab === "1" })}
                  onClick={() => toggleTab("1")}
                >
                  All
                </NavLink>
              </NavItem>
              <NavItem>
                <NavLink
                  href="#"
                  className={classnames({ active: activeTab === "2" })}
                  onClick={() => toggleTab("2")}
                >
                  Alerts
                </NavLink>
              </NavItem>
            </Nav>
          </div>
        </div>

        <TabContent activeTab={activeTab}>
          <TabPane tabId="1" className="py-2 ps-2">
            <SimpleBar style={{ maxHeight: "300px" }} className="pe-2">
              {notifications.length === 0 ? (
                <div className="text-center py-4">
                  <img src={bell} alt="bell" height="60" />
                  <h6 className="mt-2 text-muted">No notifications yet</h6>
                </div>
              ) : (
                notifications.map((n) => (
                  <div
  key={n._id}
  onClick={() => markAsRead(n._id)}
 className={`text-reset notification-item d-block dropdown-item position-relative ${
  !n.isRead ? "bg-light" : "bg-white"
}`}
  style={{ cursor: "pointer", borderRadius: "6px" }}
>

                    <div className="d-flex">
                      <div className="avatar-xs me-3">
                        <span className="avatar-title bg-info-subtle text-info rounded-circle fs-16">
                          <i className="bx bx-bell"></i>
                        </span>
                      </div>
                      <div className="flex-grow-1">
                        <h6 className="mt-0 mb-1 fs-13 fw-semibold">{n.title}</h6>
                        <p className="mb-1 fs-13 text-muted">{n.message}</p>
                        <p className="mb-0 fs-11 fw-medium text-uppercase text-muted">
                          {new Date(n.createdAt).toLocaleString()}
                        </p>
                      </div>
                    </div>
                  </div>
                ))
              )}
            </SimpleBar>
          </TabPane>
        </TabContent>
      </DropdownMenu>
    </Dropdown>
  );
};

export default NotificationDropdown;
